

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Environment } from '@/interfaces/Environment';
import { Cutoverplan } from '@/interfaces/Cutoverplan';

@Component({})
export default class CutoverplanBaseTabEnvironmentInput extends Vue {
  selectedEnvironment: number | null = null;

  @Prop()
  environments!: Environment[];

  @Prop()
  label!: string;

  @Prop()
  type?: string;

  @Prop()
  disabled?: boolean;

  @Prop()
  hint?: string;

  @Prop()
  propertyKey!: 'name' | 'app_abbreviation' | 'planned_start';

  @Prop()
  cutoverplan!: Cutoverplan;

  set selectedEnvironmentValue(value: string) {
    if (!this.selectedEnvironment) {
      this.cutoverplan[this.propertyKey] = value;
      return;
    }
    const cutoverplanEnvironment = this.cutoverplan.environments.find(
      ({ environment_id }) => environment_id === this.selectedEnvironment
    );
    if (!cutoverplanEnvironment) throw new Error();
    cutoverplanEnvironment[this.propertyKey] = value;
  }

  get selectedEnvironmentValue(): string {
    if (!this.selectedEnvironment) {
      return this.cutoverplan[this.propertyKey] || '';
    }
    const cutoverplanEnvironment = this.cutoverplan.environments.find(
      ({ environment_id }) => environment_id === this.selectedEnvironment
    );
    if (!cutoverplanEnvironment) throw new Error();
    return cutoverplanEnvironment[this.propertyKey] || '';
  }

  @Prop()
  globalSelectedEnvironment?: number;

  @Watch('globalSelectedEnvironment')
  watchGlobalSelectedEnvironment(value: number) {
    this.selectedEnvironment = value || null;
  }

  created() {
    this.selectedEnvironment = this.globalSelectedEnvironment || null;
  }
}
